export const SEWP_LOGO = 'https://cdn.magicpatterns.com/uploads/hysN52DX7M9wLYoYmrQ523/ContractHolder_logo.png';

// Placeholder — replace with the hosted PDF URL once the guide is published.
export const ORDERING_GUIDE_URL = '#ordering-guide';
export const sewpCategories = [{
  code: 'Category B',
  name: 'Enterprise-Wide IT Service Solutions',
  description: 'Enterprise-level infrastructure and managed services.'
}, {
  code: 'Category C',
  name: 'IT Mission-Based Services',
  description: 'Specialized, mission-oriented technology, cybersecurity, and consulting services.'
}];
export const contractInfo: {
  label: string;
  value: string;
}[] = [{
  label: 'Contract Type',
  value: 'GWAC (multi-award)'
}, {
  label: 'Category B Contract #',
  value: "80TECH26D0747"
}, {
  label: 'Category C Contract #',
  value: "80TECH26D0892"
}, {
  label: 'Effective Ordering Period',
  value: 'Nov 1, 2026 – Oct 31, 2036'
}, {
  label: 'SEWP Surcharge',
  value: '0.34%'
}, {
  label: 'UEI',
  value: 'DWT1XD8JT8M4'
}, {
  label: 'CAGE Code',
  value: '4RNU2'
}, {
  label: 'Business Classification',
  value: 'SBA Certified Service-Disabled Veteran-Owned Small Business'
}];
export const pmContacts = [{
  role: 'SEWP VI Program Manager'
}, {
  role: 'SEWP VI Deputy Program Manager'
}, {
  role: 'SEWP VI Contracts Representative'
}];
export const fairOpportunityIntro = ['Contractors will be provided a fair opportunity at the individual order level as appropriate per FAR Part 16.505(b), including the SEWP RFQ tools. No documentation for the order selection is required to be submitted with the order. All such documentation is to be maintained by the issuing procurement office.', 'The Contractor shall not market, quote or otherwise offer for sale, any IT Solutions not listed under this contract, until the said solutions are included in the SEWP database of record, and available to all Government end-users.', 'If the Government issues a Request For Information (RFI) as part of market research, the Contractor may provide items not yet listed on their SEWP contract as part of a market research quote if:'];
export const fairOpportunityList = ['All such items are clearly marked as not yet available on their SEWP contract; and', 'The contractor submits a technology refreshment request to add those products to their contract.'];
export const fairOpportunityRest = ['If the Government issues a Request For Quote (RFQ) or a Market Research Request (MRR), the Contractor may only respond with items available on their Contract and the price of each item shall be no greater than the price in Attachment F SEWP database of record at the time the quote is issued. If the Contractor has insufficient items on their contract to fully respond to the Formal RFQ, the Contractor must respond with a No Bid.', 'Unless the RFQ specifically allows for partial quotes, the Contractor must respond fully to all requirements specified in the RFQ.', 'When submitting a quote to a government end-user, the contractor must clearly state the length of time the quote is valid. The contractor shall honor any order submitted within the stated time period of a quote.', 'When responding to an RFI or RFQ issued from the NASA SEWP RFQ on-line quoting system, the Contractor must respond as outlined in Attachment C: Contract Holder User Manual (CHUM).', 'Contract Holders are prohibited from using Government information posted on the NASA SEWP Contract Holder Only Page, such as RFQs, RFIs, etc., for purposes other than proposing on SEWP requirements. This includes Contract Holders providing third parties with SEWP information and requirements for the purpose of assisting companies, that are not SEWP Contract Holders, with providing unsolicited proposals to meet agency requirements already posted to the NASA SEWP RFQ on-line quoting system.'];
export const orderingSupport = [{
  title: 'How to Obtain a Quote',
  body: 'Contact the New River Systems SEWP VI Program Manager or Deputy Program Manager with your requirement. We will respond through the NASA SEWP RFQ system or directly with a quote that states its validity period.',
  contact: "PMO:\xA0SEWP-VI@NewRiverSystems.com"
}, {
  title: 'Installation, Warranty & Support',
  body: 'Installation, warranty, maintenance, and technical support terms vary by service offering and will be defined at the Task Order level. Contact the NRS SEWP PMO for specifics on your order.',
  contact: "Support:\xA0SEWP-VI@NewRiverSystems.com"
}, {
  title: 'Troubleshooting an Order',
  body: 'If an order has an issue with status, delivery, invoicing, or modifications, contact the NRS SEWP PMO and include your order number so we can resolve it quickly.',
  contact: "Support:\xA0SEWP-VI@NewRiverSystems.com"
}];
export const orderingGuideContents = ['SEWP Overview', 'Fair Opportunity', 'Contact Information', "What's in Scope for SEWP VI (Categories B & C)", 'Ordering Process'];